"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FrontEndLoginModel model module.
 * @module model/FrontEndLoginModel
 * @version 1.1.3-alpha.1
 */
class FrontEndLoginModel {
  /**
   * Constructs a new <code>FrontEndLoginModel</code>.
   * Holds the information for the second login step (user id, password, browser_id)
   * @alias module:model/FrontEndLoginModel
   * @param user_id {String} User's id
   * @param password {String} User's password
   * @param browser_id {String} Browser unique id. A session is opened for each id and must be activated with a 2-step authentication process (an e-mail with an activation id is sent to the user)
   */
  constructor(user_id, password, browser_id) {
    FrontEndLoginModel.initialize(this, user_id, password, browser_id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, user_id, password, browser_id) {
    obj['user_id'] = user_id;
    obj['password'] = password;
    obj['browser_id'] = browser_id;
  }

  /**
   * Constructs a <code>FrontEndLoginModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FrontEndLoginModel} obj Optional instance to populate.
   * @return {module:model/FrontEndLoginModel} The populated <code>FrontEndLoginModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FrontEndLoginModel();
      if (data.hasOwnProperty('user_id')) {
        obj['user_id'] = _ApiClient.default.convertToType(data['user_id'], 'String');
      }
      if (data.hasOwnProperty('password')) {
        obj['password'] = _ApiClient.default.convertToType(data['password'], 'String');
      }
      if (data.hasOwnProperty('browser_id')) {
        obj['browser_id'] = _ApiClient.default.convertToType(data['browser_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FrontEndLoginModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FrontEndLoginModel</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of FrontEndLoginModel.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['user_id'] && !(typeof data['user_id'] === 'string' || data['user_id'] instanceof String)) {
      throw new Error("Expected the field `user_id` to be a primitive type in the JSON string but got " + data['user_id']);
    }
    // ensure the json data is a string
    if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
      throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
    }
    // ensure the json data is a string
    if (data['browser_id'] && !(typeof data['browser_id'] === 'string' || data['browser_id'] instanceof String)) {
      throw new Error("Expected the field `browser_id` to be a primitive type in the JSON string but got " + data['browser_id']);
    }
    return true;
  }
}
FrontEndLoginModel.RequiredProperties = ["user_id", "password", "browser_id"];

/**
 * User's id
 * @member {String} user_id
 */
FrontEndLoginModel.prototype['user_id'] = undefined;

/**
 * User's password
 * @member {String} password
 */
FrontEndLoginModel.prototype['password'] = undefined;

/**
 * Browser unique id. A session is opened for each id and must be activated with a 2-step authentication process (an e-mail with an activation id is sent to the user)
 * @member {String} browser_id
 */
FrontEndLoginModel.prototype['browser_id'] = undefined;
var _default = FrontEndLoginModel;
exports.default = _default;